export const iconFontAwesomeHouseholdSheetPlastic = (
	<i className="fa-solid fa-sheet-plastic"></i>
);
